export default function loopingImages() {
	return {
		loop: false,
		images: null,
		activeImage: null,
		init() {
			this.images = this.$root.querySelectorAll("figure");
			this.activeImage = this.images[0].dataset.id;

			let interval;
			let currentIndex = 0;
			const startInterval = () => {
				interval = setInterval(() => {
					currentIndex = (currentIndex + 1) % this.images.length;
					this.activeImage = this.images[currentIndex].dataset.id;
				}, 1000);
			};
			const stopInterval = () => {
				clearInterval(interval);
			};

			const observer = new MutationObserver((mutationsList) => {
				for (const mutation of mutationsList) {
					if (
						mutation.type === "attributes" &&
						mutation.attributeName === "class"
					) {
						if (mutation.target.classList.contains("active")) {
							this.loop = true;
						} else {
							this.loop = false;
						}
					}
				}
			});
			observer.observe(this.$root, { attributes: true, subtree: false });

			this.$watch("loop", (newValue) => {
				if (newValue) {
					startInterval();
				} else {
					stopInterval();
				}
			});
		},
	};
}
